import Container from '@admin/components/container'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Clone extends React.Component {

  static contextTypes = {
    provider: PropTypes.object,
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    plans: PropTypes.array,
    signup_page: PropTypes.object
  }

  state = {
    config: {}
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { plans, signup_page } = this.props
    const { provider } = this.context
    return {
      title: 't(Duplicate Signup Page)',
      action: `/api/admin/truevail/admin/signup_pages/${signup_page.id}/clone`,
      method: 'POST',
      saveText: 't(Clone)',
      onCancel: this._handleCancel,
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Title)', 
              name: 'title', 
              type: 'textfield', 
              placeholder: 't(Enter the title)', 
              required: true, 
              defaultValue: `Copy of ${signup_page.title}` 
            },
            { 
              label: 't(Owner)', 
              name: 'owner_id', 
              type: 'dropdown', 
              endpoint: '/api/admin/truevail/admin/agencies', 
              valueKey: 'team.id', 
              textKey: 'team.title', 
              required: true, 
              defaultValue: signup_page.owner.id
            },
            { 
              label: 't(Affiliate)', 
              name: 'affiliate_id', 
              type: 'dropdown', 
              endpoint: '/api/admin/truevail/admin/affiliates', 
              valueKey: 'id',
              textKey: 'team.title', 
              required: true, 
              defaultValue: signup_page.affiliate.id
            },
            { 
              label: 't(URL)', 
              name: 'permalink', 
              type: 'permalinkfield', 
              prefix: '/signup', 
              required: true, 
              host: provider.admin_host, 
              placeholder: '/path/to/signup' 
            }
          ]
        },
        {
          label: 't(Service Details)',
          type: 'segment',
          fields: [
            {
              label: 't(Entity)',
              name: 'entity_type',
              type: 'dropdown',
              options: [
                { value: 'advisor', text: 't(Advisor)' },
                { value: 'agency', text: 't(Agency)' },
                { value: 'supplier', text: 't(Supplier)' }
              ],
              defaultValue: signup_page.entity_type
            },
            {
              label: 't(Pricing Model)',
              name: 'pricing_model_id',
              type: 'dropdown',
              endpoint: '/api/admin/truevail/admin/pricing_models',
              valueKey: 'id',
              textKey: 'title',
              required: true,
              defaultValue: signup_page.pricing_model_id
            },
            {
              label: 't(Monthly Plan)',
              name: 'monthly_plan_id',
              type: 'dropdown',
              options: plans.filter(plan => {
                return plan.title.search('month') >= 0
              }).map(plan => ({
                value: plan.id,
                text: plan.title
              })),
              defaultValue: signup_page.monthly_plan_id
            },
            {
              label: 't(Yearly Plan)',
              name: 'yearly_plan_id',
              type: 'dropdown',
              options: plans.filter(plan => {
                return plan.title.search('year') >= 0
              }).map(plan => ({
                value: plan.id,
                text: plan.title
              })),
              required: true,
              defaultValue: signup_page.yearly_plan_id
            },
            {
              label: 't(Setup Fee)',
              name: 'config.setup_fee',
              type: 'moneyfield',
              required: true,
              defaultValue: signup_page.config.setup_fee
            },
            {
              label: 't(Free Setup)',
              name: 'config.free_setup',
              type: 'checkbox',
              defaultValue: signup_page.config.free_setup
            },
            {
              label: 't(Trial Length)',
              name: 'config.trial_length',
              type: 'numberfield',
              required: true,
              defaultValue: signup_page.config.trial_length
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSuccess(signup_page) {
    this.context.router.push(`/truevail/admin/signup_pages/${signup_page.id}`)
    this.context.modal.close()
  }

}

const mapResources = (props, context) => ({
  plans: '/api/admin/subscriptions/services/3/plans'
})

export default Container(mapResources)(Clone)
